// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* DO NOT EDIT
@todo This file is copied from GUI and should be pulled out into a shared library.
See https://github.com/LLK/scratch-paint/issues/13 */

/* 35% transparent version of looks-secondary */

.color-button_color-button_Pwl9t {
  height: 2rem;
  width: 3rem;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.color-button_color-button-swatch_JUQaw {
  position: relative;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  cursor: pointer;
  -webkit-flex-basis: 2rem;
      -ms-flex-preferred-size: 2rem;
          flex-basis: 2rem;
  -webkit-flex-shrink: 0;
      -ms-flex-negative: 0;
          flex-shrink: 0;
  height: 100%;
  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);
}

[dir='ltr'] .color-button_color-button-swatch_JUQaw {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}

[dir='rtl'] .color-button_color-button-swatch_JUQaw {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}

.color-button_color-button-arrow_i6m1v {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-user-select: none;
     -moz-user-select: none;
      -ms-user-select: none;
          user-select: none;
  cursor: pointer;
  -webkit-flex-basis: 1rem;
      -ms-flex-preferred-size: 1rem;
          flex-basis: 1rem;
  -webkit-flex-shrink: 0;
      -ms-flex-negative: 0;
          flex-shrink: 0;
  height: 100%;

  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);

  -webkit-box-align: center;

  -webkit-align-items: center;

      -ms-flex-align: center;

          align-items: center;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
      -ms-flex-pack: center;
          justify-content: center;
  color: #575e75;
  font-size: 0.75rem;
}

[dir='ltr'] .color-button_color-button-arrow_i6m1v {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  border-left: none;
}

[dir='rtl'] .color-button_color-button-arrow_i6m1v {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  border-right: none;
}

.color-button_swatch-icon_yc9Y1 {
  width: 1.75rem;
  margin: auto;
  /* Make sure it appears above the outline box */
  z-index: 2;
}

.color-button_outline-swatch_GiHXC:after {
  content: '';
  position: absolute;
  top: calc(0.5rem);
  left: calc(0.5rem);
  width: 0.75rem;
  height: 0.75rem;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.25);
  /* Make sure it appears below the transparent icon */
  z-index: 1;
}
`, "",{"version":3,"sources":["webpack://./../scratch-paint/src/components/color-button/color-button.css"],"names":[],"mappings":"AAAA;;oDAEoD;;AAEpD,+CAA+C;;AAE/C;EACE,YAAY;EACZ,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf,wBAAwB;MACpB,6BAA6B;UACzB,gBAAgB;EACxB,sBAAsB;MAClB,oBAAoB;UAChB,cAAc;EACtB,YAAY;EACZ,sDAAsD;AACxD;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,aAAa;EACb,yBAAyB;KACtB,sBAAsB;MACrB,qBAAqB;UACjB,iBAAiB;EACzB,eAAe;EACf,wBAAwB;MACpB,6BAA6B;UACzB,gBAAgB;EACxB,sBAAsB;MAClB,oBAAoB;UAChB,cAAc;EACtB,YAAY;;EAEZ,sDAAsD;;EAEtD,yBAAyB;;EAEzB,2BAA2B;;MAEvB,sBAAsB;;UAElB,mBAAmB;EAC3B,wBAAwB;EACxB,+BAA+B;MAC3B,qBAAqB;UACjB,uBAAuB;EAC/B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,+CAA+C;EAC/C,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,qCAAqC;EACrC,oDAAoD;EACpD,UAAU;AACZ","sourcesContent":["/* DO NOT EDIT\n@todo This file is copied from GUI and should be pulled out into a shared library.\nSee https://github.com/LLK/scratch-paint/issues/13 */\n\n/* 35% transparent version of looks-secondary */\n\n.color-button {\n  height: 2rem;\n  width: 3rem;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.color-button-swatch {\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  cursor: pointer;\n  -webkit-flex-basis: 2rem;\n      -ms-flex-preferred-size: 2rem;\n          flex-basis: 2rem;\n  -webkit-flex-shrink: 0;\n      -ms-flex-negative: 0;\n          flex-shrink: 0;\n  height: 100%;\n  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n}\n\n[dir='ltr'] .color-button-swatch {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n}\n\n[dir='rtl'] .color-button-swatch {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n}\n\n.color-button-arrow {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: pointer;\n  -webkit-flex-basis: 1rem;\n      -ms-flex-preferred-size: 1rem;\n          flex-basis: 1rem;\n  -webkit-flex-shrink: 0;\n      -ms-flex-negative: 0;\n          flex-shrink: 0;\n  height: 100%;\n\n  border: 1px solid var(--paint-ui-pane-border, #d9d9d9);\n\n  -webkit-box-align: center;\n\n  -webkit-align-items: center;\n\n      -ms-flex-align: center;\n\n          align-items: center;\n  -webkit-box-pack: center;\n  -webkit-justify-content: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n  color: #575e75;\n  font-size: 0.75rem;\n}\n\n[dir='ltr'] .color-button-arrow {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-left: none;\n}\n\n[dir='rtl'] .color-button-arrow {\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  border-right: none;\n}\n\n.swatch-icon {\n  width: 1.75rem;\n  margin: auto;\n  /* Make sure it appears above the outline box */\n  z-index: 2;\n}\n\n.outline-swatch:after {\n  content: '';\n  position: absolute;\n  top: calc(0.5rem);\n  left: calc(0.5rem);\n  width: 0.75rem;\n  height: 0.75rem;\n  background: white;\n  border: 1px solid rgba(0, 0, 0, 0.25);\n  /* Make sure it appears below the transparent icon */\n  z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-button": `color-button_color-button_Pwl9t`,
	"colorButton": `color-button_color-button_Pwl9t`,
	"color-button-swatch": `color-button_color-button-swatch_JUQaw`,
	"colorButtonSwatch": `color-button_color-button-swatch_JUQaw`,
	"color-button-arrow": `color-button_color-button-arrow_i6m1v`,
	"colorButtonArrow": `color-button_color-button-arrow_i6m1v`,
	"swatch-icon": `color-button_swatch-icon_yc9Y1`,
	"swatchIcon": `color-button_swatch-icon_yc9Y1`,
	"outline-swatch": `color-button_outline-swatch_GiHXC`,
	"outlineSwatch": `color-button_outline-swatch_GiHXC`
};
export default ___CSS_LOADER_EXPORT___;
